const SERVICE_NAMES = {
  1: 'Chairlift & Cable Car',
  2: 'Sightseeing',
  3: 'Boating',
  6: 'Softwheel Train',
  7: 'General e-ticketing',
}

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return ''
  const [year, month, day] = dateStr.split('-')
  if (!year || !month || !day) return dateStr
  return `${day}/${month}/${year}`
}

export const getServiceName = (serviceId, serviceSlug) => {
  const mappedName = SERVICE_NAMES[Number(serviceId)]
  if (mappedName) return mappedName

  if (!serviceSlug) return 'Dashboard'

  return serviceSlug
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export const getCityName = (cityId, cities = []) => {
  if (!cityId) return ''
  const city = cities.find((item) => String(item.id) === String(cityId))
  return city?.name || ''
}

export const buildReportTitle = (serviceName, cityName, startDate, endDate) => {
  const dateRange = `(${formatDisplayDate(startDate)} - ${formatDisplayDate(endDate)})`
  if (cityName) {
    return `${serviceName} - ${cityName} ${dateRange}`
  }
  return `${serviceName} ${dateRange}`
}

export const toSafeFilename = (title) =>
  title.replace(/[\\/:*?"<>|]/g, '-').replace(/\s+/g, ' ').trim()
